import { Component, Inject, Input, OnChanges, OnDestroy, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { ContentfulService } from 'src/app/shared/services/contentful.service';
import { Subscription } from 'rxjs';
import { CountrycurrencypageService } from '../countrycurrencypage.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { UrlParamsPipe } from 'src/app/shared/utilities/url-params.pipe';

@Component({
  selector: 'app-country-currency-coverage',
  templateUrl: './country-currency-coverage.component.html',
  styleUrls: ['./country-currency-coverage.component.scss'],
  imports: [CommonModule, UrlParamsPipe],
})
export class CountryCurrencyCoverageComponent implements OnInit, OnDestroy, OnChanges {
  @Input() pageData: any;
  @ViewChild('registerLink') registerLink: any;
  activeTabIndex = 0;
  continentTabs: any;
  queryParams: any;
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private countryCurrencyPageService: CountrycurrencypageService,
    private router: ActivatedRoute
  ) {
    this.subscriptions = [];
    this.router.queryParams.subscribe(params => {
      this.queryParams = params;
    });
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach(subscription => {
        subscription.unsubscribe();
      });
    }
  }

  subscriptions: Subscription[];
  coverageData: any;

  ngOnInit(): void {
    this.countryCurrencyPageService.coverage$.subscribe(data => {
      
    });
  }
  ngOnChanges(): void {
    const continentParam = this.router.snapshot.params['continent'];
    if (!continentParam) return;
    const continent = continentParam.split('-').join(' ');
    const capitalizedContinent = this.capitalizeWords(continent);
    const data = this.pageData?.coverage?.fields;
    if (data != null) {
      this.coverageData = {
        tabs: data?.component1 || [],
        header: data?.title || '',
        paragraph: data?.content || '',
      };
      this.continentTabs = this.coverageData?.tabs?.map((el:any) => el?.fields?.tagText || '') || [];
      const isServer = !isPlatformBrowser(this.platformId);
      if (isServer) return;
      const index = this.continentTabs?.indexOf(capitalizedContinent);
      if(index > -1){
        this.activeTabIndex = index;
      }
    }
  }
  tabHandler(index: number) {
    this.activeTabIndex = index;
  }
  capitalizeWords(str:any) {
    // Handle empty or non-string inputs
    if (!str || typeof str !== 'string') {
      return '';
    }

    // Split the string into an array of words
    const words = str.split(' ');

    // Map over each word to capitalize its first letter
    const capitalizedWords = words.map(word => {
      if (word.length === 0) {
        return ''; // Handle empty words (e.g., multiple spaces)
      }
      return word.charAt(0).toUpperCase() + word.slice(1);
    });

    // Join the capitalized words back into a single string
    return capitalizedWords.join(' ');
  }
}
